/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_SubtitleInputs */

const zh_about_subtitle = /** @type {(inputs: About_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`StudyOS 是一个 AI 驱动的智能教学平台，致力于让每一位老师都能轻松创作引人入胜的互动教学内容，让每一位学生都能享受个性化的学习体验。`)
};

const en_about_subtitle = /** @type {(inputs: About_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`StudyOS is an AI-powered smart teaching platform dedicated to helping every educator create engaging, interactive educational content effortlessly, and every student enjoy a personalized learning experience.`)
};

const es_about_subtitle = /** @type {(inputs: About_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`StudyOS es una plataforma educativa inteligente impulsada por IA, dedicada a ayudar a cada educador a crear contenido interactivo atractivo sin esfuerzo, y a cada estudiante a disfrutar de una experiencia de aprendizaje personalizada.`)
};

/**
* | output |
* | --- |
* | "StudyOS is an AI-powered smart teaching platform dedicated to helping every educator create engaging, interactive educational content effortlessly, and every..." |
*
* @param {About_SubtitleInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const about_subtitle = /** @type {((inputs?: About_SubtitleInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_SubtitleInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_about_subtitle(inputs)
	if (locale === "en") return en_about_subtitle(inputs)
	return es_about_subtitle(inputs)
});